<div class="booking-pricelist-dialog" data-test="booking-pricelist-dialog">
  <h3>Dynamisk prislista</h3>

  <div mat-dialog-content>
    <div class="loading" *ngIf="loading" data-test="booking-pricelist-loading">
      <mat-spinner diameter="36"></mat-spinner>
      <p>Hämtar prislista...</p>
    </div>

    <ng-container *ngIf="!loading && priceList?.prices?.length">
      <dl class="metadata">
        <ng-container *ngIf="priceList?.entryDate">
          <dt>Parkering startdatum:</dt>
          <dd>{{ priceList?.entryDate | date : 'mediumDate' }}</dd>
        </ng-container>
        <ng-container *ngIf="priceList?.downloadDate">
          <dt>Prislista hämtad:</dt>
          <dd>{{ priceList?.downloadDate | date : 'mediumDate' }}</dd>
        </ng-container>
        <ng-container *ngIf="priceList?.extraDayPrice !== undefined">
          <dt>Pris per extra dag:</dt>
          <dd>{{ priceList?.extraDayPrice | currency : 'SEK' : 'symbol' : '1.0-2' }}</dd>
        </ng-container>
      </dl>

      <div class="table-wrapper">
        <mat-table [dataSource]="priceList?.prices || []">
          <ng-container matColumnDef="days">
            <mat-header-cell *matHeaderCellDef>Dagar</mat-header-cell>
            <mat-cell *matCellDef="let price">{{ price.days }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="price">
            <mat-header-cell *matHeaderCellDef>Pris</mat-header-cell>
            <mat-cell *matCellDef="let price">
              {{ price.price | currency : 'SEK' : 'symbol' : '1.0-2' }}
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>
    </ng-container>

    <p class="empty" *ngIf="!loading && !priceList?.prices?.length" data-test="booking-pricelist-empty">
      Det finns ingen prislista tillgänglig för bokningen.
    </p>
  </div>

  <div mat-dialog-actions class="actions" align="end">
    <button mat-button (click)="close()">Stäng</button>
  </div>
</div>
